
// AUTO GENERATED FILE
export const APP_VERSION = "0.9.25";
export const BUILD_HASH = "7898f104";
export const BUILD_DATE = "02.10.2026 13:12:59";
